import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Loadable from 'react-loadable';
import withSizes from 'react-sizes';
import { compose } from 'redux';
import AppToolbar from './AppToolbar';


const AppMenu = Loadable({
	loader: () => import('./AppMenu'),
	loading: () => null
});

class LayoutComponent extends Component {
	state = {
		open: true
	};

	handleLogout = () => {
		this.props.logout(() => {
			if (this.props.isMobile) {
				this.setState({ open: false });
			}
		});
	};

	handleDrawerToggle = () => {
		this.setState({ open: !this.state.open });
	};

	closeMenuOnMobile = () => {
		if (this.props.isMobile) {
			this.setState({ open: false });
		}
	};

	renderMenu() {
		const { isAuthenticated, isUserAdmin } = this.props;

		return (
			<AppMenu
				open={this.state.open}
				isAuthenticated={isAuthenticated}
				isUserAdmin={isUserAdmin}
				handleLogout={this.handleLogout}
				menuToggle={this.handleDrawerToggle}
				closeMenuOnMobile={this.closeMenuOnMobile}
			/>
		);
	}

	render() {
		const { isAuthenticated } = this.props;
		const { open } = this.state;

		return (
			<div className="sds-page-wrapper">
				<AppToolbar
					open={open}
					isAuthenticated={isAuthenticated}
					menuToggle={this.handleDrawerToggle}
					closeMenuOnMobile={this.closeMenuOnMobile}
				/>
				<div className="sds-page">
					{this.renderMenu()}
					<div className="sds-page__content">{this.props.children}</div>
				</div>
			</div>
		);
	}
}

LayoutComponent.propTypes = {
	isAuthenticated: PropTypes.bool.isRequired,
	isUserAdmin: PropTypes.bool.isRequired,
	token: PropTypes.string,
	logout: PropTypes.func.isRequired
};

const mapSizesToProps = ({ width }) => ({
	isMobile: width <= 992
});

export default compose(injectIntl)(withSizes(mapSizesToProps)(LayoutComponent));
